import { useLayoutEffect, useEffect } from 'react';

// Hook for usage inside SSR projects
const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
export default useIsomorphicLayoutEffect;